import { SchoolYearModel } from "../models/SchoolYearModel";
import { IHttpRequestService } from "./HttpRequestService";

export interface ISchoolYearService {
    GetSchoolYearsForDateRange(date: string): Promise<SchoolYearModel[]>;
    GetAll(): Promise<SchoolYearModel[]>;
    GetSchoolYearForHolidayBannerDisplay(): Promise<SchoolYearModel | null>;
}

export class SchoolYearService implements ISchoolYearService {
    constructor(private httpRequestService: IHttpRequestService) {}

    public async GetSchoolYearsForDateRange(date: string): Promise<SchoolYearModel[]> {
        try {
            const { data } = await this.httpRequestService.Get<SchoolYearModel[]>(`/api/v1/SchoolYear/date/${date}`);
            if(!data || data.length == 0) { return []; }
            return data as SchoolYearModel[];
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return [];
    }

    public async GetAll(): Promise<SchoolYearModel[]> {
        try {
            const { data } = await this.httpRequestService.Get<SchoolYearModel[]>(`/api/v1/SchoolYear`);
            if(!data || data.length == 0) { return []; }
            return data as SchoolYearModel[];
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return [];
    }

    public async GetSchoolYearForHolidayBannerDisplay(): Promise<SchoolYearModel | null> {
        try {
            const { data } = await this.httpRequestService.Get<SchoolYearModel>(`/api/v1/SchoolYear/HolidayBannerDisplay`);
            if(!data) { return null; }
            return data as SchoolYearModel;
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return null;
    }
}
